// 视频管理模块多语言配置
export const videoManage = {
  'zh-CN': {
    // 按钮和操作
    addVideo: '添加视频',
    detail: '详情',
    edit: '编辑',
    delete: '删除',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    restore: '恢复默认',
    
    // 表格列标题
    serialNumber: '序号',
    uploader: '上传者',
    uploadTime: '上传时间',
    playVolume: '播放量pv',
    guestCount: '获客人数',
    likes: '点赞',
    forwardCount: '转发次数',
    followCount: '关注人数',
    title: '标题',
    recommendedGoods: '推荐商品',
    address: '地址',
    cover: '封面',
    status: '状态',
    operation: '操作',
    
    // 状态文本
    offline: '已下架',
    online: '已上架',
    shelf: '上架',
    unshelf: '下架',
    
    // 对话框标题
    addVideoTitle: '添加视频',
    selectGoodsTitle: '选择商品',
    
    // 表单标签
    videoName: '视频名称',
    addLocation: '添加定位',
    videoContent: '视频内容',
    videoCover: '视频封面',
    recommendedGoodsLabel: '推荐商品',
    productSelection: '商品选择',
    
    // 占位符和提示
    enterVideoName: '请输入视频名称',
    enterLocation: '请输入添加位置',
    uploadVideoContent: '请上传视频内容',
    uploadVideoCover: '请上传视频封面',
    enterProductRecommendation: '请输入商品推荐语',
    
    // 上传提示
    uploadTip: '只能上传MP4文件，且不超过10M',
    imageUploadTip: '上传图片的最佳尺寸：750像素*750像素，其他尺寸会影响页面效果，格式png，jpeg，jpg。大小不超过2M',
    
    // 商品表格列
    productId: '产品id',
    product: '产品',
    category: '分类',
    price: '价格',
    stock: '库存',
    totalSales: '总销量',
    publishTime: '发布时间',
    
    // 消息提示
    uploading: '正在上传',
    uploadSuccess: '上传成功',
    saving: '正在保存',
    saveSuccess: '保存成功',
    videoSizeLimit: '上传视频大小不能超过 30MB!',
    confirmDelete: '确定要删除吗？',
    confirmShelf: '确定要上架这个视频吗？',
    confirmUnshelf: '确定要下架这个视频吗？',
    
    // 时间相关
    justNow: '刚刚',
    minutesAgo: '分钟前',
    hoursAgo: '小时前',
    daysAgo: '天前',
    
    // 权限相关
    canSelectAllOrOnlyShowMallModule: '可全选或只显示商城模块'
  },
  'zh-TW': {
    // 按钮和操作
    addVideo: '添加視頻',
    detail: '詳情',
    edit: '編輯',
    delete: '刪除',
    confirm: '確定',
    cancel: '取消',
    save: '保存',
    restore: '恢復默認',
    
    // 表格列标题
    serialNumber: '序號',
    uploader: '上傳者',
    uploadTime: '上傳時間',
    playVolume: '播放量pv',
    guestCount: '獲客人數',
    likes: '點讚',
    forwardCount: '轉發次數',
    followCount: '關注人數',
    title: '標題',
    recommendedGoods: '推薦商品',
    address: '地址',
    cover: '封面',
    status: '狀態',
    operation: '操作',
    
    // 状态文本
    offline: '已下架',
    online: '已上架',
    shelf: '上架',
    unshelf: '下架',
    
    // 对话框标题
    addVideoTitle: '添加視頻',
    selectGoodsTitle: '選擇商品',
    
    // 表单标签
    videoName: '視頻名稱',
    addLocation: '添加定位',
    videoContent: '視頻內容',
    videoCover: '視頻封面',
    recommendedGoodsLabel: '推薦商品',
    productSelection: '商品選擇',
    
    // 占位符和提示
    enterVideoName: '請輸入視頻名稱',
    enterLocation: '請輸入添加位置',
    uploadVideoContent: '請上傳視頻內容',
    uploadVideoCover: '請上傳視頻封面',
    enterProductRecommendation: '請輸入商品推薦語',
    
    // 上传提示
    uploadTip: '只能上傳MP4文件，且不超過10M',
    imageUploadTip: '上傳圖片的最佳尺寸：750像素*750像素，其他尺寸會影響頁面效果，格式png，jpeg，jpg。大小不超過2M',
    
    // 商品表格列
    productId: '產品id',
    product: '產品',
    category: '分類',
    price: '價格',
    stock: '庫存',
    totalSales: '總銷量',
    publishTime: '發布時間',
    
    // 消息提示
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    saving: '正在保存',
    saveSuccess: '保存成功',
    videoSizeLimit: '上傳視頻大小不能超過 30MB!',
    confirmDelete: '確定要刪除嗎？',
    confirmShelf: '確定要上架這個視頻嗎？',
    confirmUnshelf: '確定要下架這個視頻嗎？',
    
    // 时间相关
    justNow: '剛剛',
    minutesAgo: '分鐘前',
    hoursAgo: '小時前',
    daysAgo: '天前',
    
    // 权限相关
    canSelectAllOrOnlyShowMallModule: '可全選或只顯示商城模塊'
  },
  'en': {
    // 按钮和操作
    addVideo: 'Add Video',
    detail: 'Detail',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    restore: 'Restore Default',
    
    // 表格列标题
    serialNumber: 'No.',
    uploader: 'Uploader',
    uploadTime: 'Upload Time',
    playVolume: 'Play Volume PV',
    guestCount: 'Guest Count',
    likes: 'Likes',
    forwardCount: 'Forward Count',
    followCount: 'Follow Count',
    title: 'Title',
    recommendedGoods: 'Recommended Goods',
    address: 'Address',
    cover: 'Cover',
    status: 'Status',
    operation: 'Operation',
    
    // 状态文本
    offline: 'Offline',
    online: 'Online',
    shelf: 'Shelf',
    unshelf: 'Unshelf',
    
    // 对话框标题
    addVideoTitle: 'Add Video',
    selectGoodsTitle: 'Select Goods',
    
    // 表单标签
    videoName: 'Video Name',
    addLocation: 'Add Location',
    videoContent: 'Video Content',
    videoCover: 'Video Cover',
    recommendedGoodsLabel: 'Recommended Goods',
    productSelection: 'Product Selection',
    
    // 占位符和提示
    enterVideoName: 'Please enter video name',
    enterLocation: 'Please enter location',
    uploadVideoContent: 'Please upload video content',
    uploadVideoCover: 'Please upload video cover',
    enterProductRecommendation: 'Please enter product recommendation',
    
    // 上传提示
    uploadTip: 'Only MP4 files can be uploaded, and the size should not exceed 10M',
    imageUploadTip: 'The best size for uploading images: 750px*750px, other sizes will affect the page effect, formats png, jpeg, jpg. Size should not exceed 2M',
    
    // 商品表格列
    productId: 'Product ID',
    product: 'Product',
    category: 'Category',
    price: 'Price',
    stock: 'Stock',
    totalSales: 'Total Sales',
    publishTime: 'Publish Time',
    
    // 消息提示
    uploading: 'Uploading...',
    uploadSuccess: 'Upload successful',
    saving: 'Saving...',
    saveSuccess: 'Save successful',
    videoSizeLimit: 'Upload video size cannot exceed 30MB!',
    confirmDelete: 'Are you sure you want to delete?',
    confirmShelf: 'Are you sure you want to shelf this video?',
    confirmUnshelf: 'Are you sure you want to unshelf this video?',
    
    // 时间相关
    justNow: 'Just now',
    minutesAgo: 'minutes ago',
    hoursAgo: 'hours ago',
    daysAgo: 'days ago',
    
    // 权限相关
    canSelectAllOrOnlyShowMallModule: 'Can select all or only show mall module'
  }
}; 